import { render, staticRenderFns } from "./IconTitle.vue?vue&type=template&id=5a7d2d1a&scoped=true&"
import script from "./IconTitle.vue?vue&type=script&lang=js&"
export * from "./IconTitle.vue?vue&type=script&lang=js&"
import style0 from "./IconTitle.vue?vue&type=style&index=0&id=5a7d2d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d2d1a",
  null
  
)

export default component.exports